import React from 'react'
import styled from 'styled-components'
import FooterBackground from '../../src/assets/images/footer-wave.svg'
import CompanyGreyLogo from '../../src/assets/images/120-logo-1c-black-resize-1.png'

export const AppFooter = (): JSX.Element => (
  <Content>
    <StyledFooter>
      <div>
        <img src={`${CompanyGreyLogo}`} alt="120Water Logo" />
      </div>
      <MainSection>
        <div>
          <span>This dashboard is powered by 120Water.</span>
        </div>
        <div>
          <span>
            <a
              target="_blank"
              href="https://120water.com/public-transparency/"
              rel="noreferrer noopener">
              Visit our website
            </a>{' '}
            to learn about how to keep our drinking water safe.
          </span>
        </div>
      </MainSection>
      <LinkSection>
        <span>
          &copy; {new Date().getFullYear()} 120Water &#183;{' '}
          <a
            target="_blank"
            href="https://120water.com/terms-of-use/"
            rel="noreferrer noopener">
            Terms and Conditions
          </a>{' '}
          &#183;{' '}
          <a
            target="_blank"
            href="https://120water.com/privacy-policy/"
            rel="noreferrer noopener">
            Privacy Policy
          </a>
        </span>
      </LinkSection>
    </StyledFooter>
  </Content>
)

const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 36, 45, 0.05);
  width: 100%;
`

const MainSection = styled.section`
  padding: 1em 0;
  font-size: 0.95em;

  span {
    color: rgba(0, 36, 45, 0.45);

    & > a {
      @extend span;
      text-decoration: underline;
      color: inherit;
    }
  }
`

const LinkSection = styled.div`
  font-size: 0.725em;

  span,
  a {
    color: rgba(0, 36, 45, 0.275);
  }
`

const StyledFooter = styled.footer`
  min-height: 250px;
  background-image: url(${FooterBackground});
  background-repeat: no-repeat, no-repeat;
  background-size: cover;
  background-position: right 0 top 50px;
  text-align: center;
  margin-top: 6rem;

  img {
    width: 100%;
    max-width: 160px;
  }

  @media only screen and (max-width: 767px) {
    background-position: right -85px top 30px;
    margin-top: 5rem;
  }
`

export default AppFooter
